import { useQuery } from '@tanstack/react-query'
import { endOfDay, format } from 'date-fns'

import { useCartStore } from '@/stores/cart-store/cartStore'

import { getRoomOffers } from '../api/getRoomOffers'

type UseGetRoomOffersParams = {
	adults: number
	childrenAges?: number[]
	selectedRoomCodes?: string[]
}

export const useOffers = ({ selectedRoomCodes, adults, childrenAges }: UseGetRoomOffersParams) => {
	const location = useCartStore.use.location()
	const { startDate, nights } = useCartStore.use.travelPeriod()
	const promotion = useCartStore.use.promotion()
	const enabled = Boolean(location && startDate && nights)

	return useQuery({
		queryKey: [
			'GET_ROOM_OFFERS',
			location!.hotelCode,
			startDate,
			nights,
			selectedRoomCodes,
			childrenAges,
			adults,
			promotion.code,
		],
		queryFn: () =>
			getRoomOffers({
				adults,
				childrenAges: childrenAges,
				hotelCode: location!.hotelCode,
				arrivalDate: format(endOfDay(startDate!), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
				nights,
				alreadySelectedRooms: selectedRoomCodes,
				promotionCode: promotion.code ?? null,
			}),
		enabled,
		staleTime: 60000,
	})
}
